import { render } from "./TeacherAssignmentsTable.vue?vue&type=template&id=76ce5729&scoped=true"
import script from "./TeacherAssignmentsTable.vue?vue&type=script&lang=js"
export * from "./TeacherAssignmentsTable.vue?vue&type=script&lang=js"

import "./TeacherAssignmentsTable.vue?vue&type=style&index=0&id=76ce5729&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76ce5729"]])

export default __exports__